export default "__VITE_ASSET__BoDInZ8j__"